'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { BodyDefault } from '@terra/ui-design-system';
import { FindingEditGeneralDetailsSection } from './FindingEditGeneralDetailsSection';
import { FindingEditTechnicalDetailsSection } from './FindingEditTechnicalDetailsSection';
import { FindingEditCvssVersionsSection } from './FindingEditCvssVersionsSection';
import { FindingEditOwaspSection } from './FindingEditOwaspSection';
import type { FindingDetailsEditFormProps } from './findingEditForm.types';

export type { FindingDetailsEditFormProps } from './findingEditForm.types';

export function FindingDetailsEditForm(props: FindingDetailsEditFormProps) {
  return (
    <VStack gap={8} w="full" alignItems="stretch">
      {props.saveError ? (
        <Box
          p={2}
          borderRadius="md"
          borderWidth="1px"
          borderColor="border.error"
          bg="bg.canvas"
        >
          <BodyDefault color="fg.error">{props.saveError}</BodyDefault>
        </Box>
      ) : null}

      <FindingEditGeneralDetailsSection
        editableFields={props.editableFields}
        statusOptions={props.statusOptions}
        categoryOptions={props.categoryOptions}
        signalsCollection={props.signalsCollection}
        runsCollection={props.runsCollection}
        assetsCollection={props.assetsCollection}
        isSearchingSignals={props.isSearchingSignals}
        isSearchingRuns={props.isSearchingRuns}
        isSearchingAssets={props.isSearchingAssets}
        currentRunValue={props.currentRunValue}
        linkedTicketUrl={props.linkedTicketUrl}
        canEditLinkedTicket={props.canEditLinkedTicket}
        hasLinkedTicket={props.hasLinkedTicket}
        sendSelectionToChatLabel={props.sendSelectionToChatLabel}
        handleFieldChange={props.handleFieldChange}
        handleStatusFieldChange={props.handleStatusFieldChange}
        handleAssetsMultiChange={props.handleAssetsMultiChange}
        handleSignalSearch={props.handleSignalSearch}
        handleRunSearch={props.handleRunSearch}
        handleAssetSearch={props.handleAssetSearch}
        handleRunChange={props.handleRunChange}
        handleSendFieldContextToChat={props.handleSendFieldContextToChat}
        handleOpenLinkedTicketDialog={props.handleOpenLinkedTicketDialog}
        getMarkableFieldProps={props.getMarkableFieldProps}
      />

      <FindingEditCvssVersionsSection {...props} />

      <FindingEditOwaspSection
        editableFields={props.editableFields}
        findingCreatedAt={props.finding.createdAt}
        owaspMarkableFieldProps={props.getMarkableFieldProps('owaspRisk')}
        onScoreChange={props.handleOwaspRiskScoreChange}
      />

      <FindingEditTechnicalDetailsSection
        findingId={props.finding.id}
        editableFields={props.editableFields}
        hasUnsavedChanges={props.hasUnsavedChanges}
        sendSelectionToChatLabel={props.sendSelectionToChatLabel}
        handleFieldChange={props.handleFieldChange}
        handlePocBlocksChange={props.handlePocBlocksChange}
        handleSendFieldContextToChat={props.handleSendFieldContextToChat}
        getMarkableFieldProps={props.getMarkableFieldProps}
      />
    </VStack>
  );
}
